import 'babel-polyfill'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import 'typeface-roboto'
import configureStore from './app/store/configureStore'
import './app/assets/styles/index.css'
import App from './App'

const store = configureStore()
const rootEl = document.getElementById('root')
const root = createRoot(rootEl)

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    root.render(
      <Provider store={store}>
        <NextApp />
      </Provider>
    )
  })
}
